import React from 'react'
import pagePic from "./../../Images/pageicon.png" ;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import verifiedPic from "./../../Images/verified.png" ; 
import { motion } from "motion/react";

const PageSearchItem = ({name , location , verified , id}) => {
  return (
    <motion.div className='search-item-card'
    initial={{
      opacity : 0 , 
      translateX : 50
    }}
    whileInView={{
      opacity : 1 , 
      translateX : 0
    }}
    >
        <div className='search-item-head'>
            <img src={pagePic} alt='pic' loading='lazy' />
            <h2>{name}</h2>
            {verified ? (<img style={{width : "16px" , height : "16px"}} src={verifiedPic} alt='verify' />) : ""}
            
        </div>
        <div className='loc-con' style={{display : "flex"}}>
            <span><FontAwesomeIcon icon={faLocationDot} /></span>
            <p className='location'>{location? `${location?.country},` :"" }  {location? `,${location?.city}`:"" }  {location? `,${location?.street}` :"" }</p>
        </div>
        <Link style={{textDecoration : "none"}} to={id}>
          <button className='get-post-btn'>Get Posts</button>
        </Link>
    </motion.div>
  )
}

export default PageSearchItem
